export default __webpack_public_path__ + "static/media/m-sub-banner-right-5.f7b93209.svg";